export default "__VITE_ASSET__7BtiZUYr__"